import { FC } from 'react';
import { SearchX } from 'lucide-react';
import { Button } from '../../components/ui/Button';

interface EmptyStateProps {
  hasFilters: boolean;
  onClearFilters: () => void;
}

export const EmptyState: FC<EmptyStateProps> = ({ hasFilters, onClearFilters }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="mb-4 rounded-full bg-gray-100 dark:bg-slate-800 p-4">
        <SearchX className="h-12 w-12 text-gray-400 dark:text-slate-500" aria-hidden="true" />
      </div>

      <h3 className="mb-2 text-lg font-semibold text-gray-900 dark:text-slate-100">
        {hasFilters ? 'No matching services found' : 'No services available'}
      </h3>

      <p className="mb-6 max-w-md text-gray-600 dark:text-slate-400">
        {hasFilters
          ? 'We could not find any services matching your current filters. Try adjusting your search criteria or clearing all filters.'
          : 'There are currently no services available. Please check back later.'}
      </p>

      {hasFilters && (
        <Button variant="outline" onClick={onClearFilters} aria-label="Clear all filters">
          Clear All Filters
        </Button>
      )}
    </div>
  );
};
